<template>
  <Layout class="g-wrapper g-vertical-block">
    <div class="c-reconciliation g-main-wrapper">
      <!-- filter -->
      <reconciliation-filter @search="searchFilterData" :loading="loading" />
      <div class="button-group">
        <div class="flex">
          <el-button v-if="permissions.includes('M21072')" @click="financeReRunData">同步数据</el-button>
          <el-upload
            class="uploader"
            action="#"
            ref="upload"
            :show-file-list="false"
            :before-upload="preUpload"
            accept="application/vnd.ms-excel,.xls,.xlsx,.csv"
          >
            <el-button>返点导入</el-button>
          </el-upload>
          <el-button @click="downFailData">返点修改模板下载</el-button>
        </div>
        <div ref="abc">
          <el-button type="primary" @click="financeExportData">数据导出</el-button>
          <el-button type="primary" @click="modalColumn = true">自定义列</el-button>
        </div>
      </div>
      <!-- table -->
      <div class="c-table-list">
        <Viewport v-model="tableHeight">
          <reconciliation-table
            :loading="loading"
            :data="tableList"
            :summaryData="summaryData"
            :columns="tableCol"
            :height="tableHeight"
            @on-refresh="getData"
            @sort-change="changeSort"
            @run-data="financeReRunData"
          />

          <el-pagination
            :total="total"
            :current-page.sync="pageIndex"
            :page-size.sync="pageSize"
            :page-sizes="[10, 30, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="changePageIndex"
            @size-change="changePageSize"
            class="pager"
            background
          />
        </Viewport>
      </div>
      <custom-column
        ref="tableCustomColsRef"
        v-model="modalColumn"
        name="ReconciliationCustomColumn"
        :data="rawTableCols"
        :sub-title="['基础信息']"
        @on-select="onTableColsChange"
      />
    </div>
    <el-dialog
      :visible.sync="resultModel"
      :close-on-click-modal="false"
      :title="`导入结果 （导入成功${success}条，失败${failure}条）`"
      width="520px"
    >
      <el-table :data="failureData" border stripe>
        <el-table-column prop="adAccount" label="账号名称" width="100" />
        <el-table-column prop="mediaName" label="媒体" width="100" />
        <el-table-column prop="msg" label="结果" width="失败原因" />
      </el-table>
      <template slot="footer">
        <div class="m-foot">
          <el-button type="primary" @click="resultOk">知道了</el-button>
        </div>
      </template>
    </el-dialog>
  </Layout>
</template>
<script>
import mixin from './mixins/mixin'
import columns from './data/cols'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { getAccountFinance, exportData, reRunData, importRebate } from '@/api/financial.model'
import ReconciliationFilter from './components/reconciliation-filter.vue'
import ReconciliationTable from './components/reconciliation-table.vue'
import CustomColumn from '@/components/converter/custom-column2.vue'
import { HOST_API } from '@/api/config'
export default {
  name: 'reconciliation',
  mixins: [mixin],
  components: { CustomColumn, ReconciliationFilter, ReconciliationTable },
  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      // 加载状态
      this.loading = true
      getAccountFinance(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info, sum_data } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list.map((ret) => {
              return ret
            })
            this.summaryData = sum_data || {}
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    downFailData() {
      window.open(`${HOST_API}/api/ptom/template/downTemplate?templateType=template_ptom_account_finance`, '_blank')
    },
    financeReRunData({ accountId }) {
      if (accountId) {
        reRunData({ beginTime: this.params.beginTime, adAccountIdStr: accountId.toString() }).then(() => {})
      } else {
        const { keyword, mediaId, opId, status, beginTime, synStatus } = this.params
        reRunData({ keyword, mediaId, opId, status, beginTime, synStatus }).then(() => {})
      }
    },
    preUpload(file) {
      this.financeImportRebate(file)
      return false
    },
    financeImportRebate(file) {
      this.$Spin.show()
      importRebate({ file }).then((data) => {
        this.$Spin.hide()
        if (data) {
          this.failure = data.failTotal
          this.success = data.successTotal
          this.failureData = data.failList
          this.resultModel = true
        }
      })
    },
    financeExportData() {
      const exportColumnOrderMap = {}
      this.tableColumns.map((item) => {
        if (item.checked) {
          exportColumnOrderMap[item.key] = item.title
        }
      })
      const params = {
        ...this.params,
        exportColumnOrderMap
      }
      exportData(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list.map((ret) => {
              return ret
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    onTableColsChange(cols) {
      this.modalColumn = false
      this.tableColumns = cols
    },
    setLocalPage(size) {
      setLocal('RECONCILIATION_PAGESIZE', size)
    }
  },
  data() {
    return {
      params: {},
      modalColumn: false, // 自定义列
      tableColumns: [],
      rawTableCols: columns,
      tableHeight: 330,
      failure: 0,
      success: 0,
      failureData: []
    }
  },
  computed: {
    tableCol() {
      return this.tableColumns.filter((ret) => ret.checked)
    },
    permissions() {
      return this.$store.state.accessAuth
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('RECONCILIATION_PAGESIZE')) || 30
  }
}
</script>
<style lang="scss" scoped>
.c-reconciliation {
  width: 100%;
  height: 100%;
  padding: 8px 8px 0;
}
.uploader {
  margin: 0 15px;
}
.button-group .flex > :first-child[class='uploader'] {
  margin-left: 0;
}
.pager {
  padding: 5px 0;
  text-align: right;
}

.button-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  .flex {
    display: flex;
  }
}
</style>
